import React from "react";

export const TelegramIcon = ({size = 40}: {size?: number}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_19993_139543)">
      <path
        d="M20 37.5C29.665 37.5 37.5 29.665 37.5 20C37.5 10.335 29.665 2.5 20 2.5C10.335 2.5 2.5 10.335 2.5 20C2.5 29.665 10.335 37.5 20 37.5Z"
        fill="url(#paint0_linear_19993_139543)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.4217 19.8154C15.5233 17.5927 18.9252 16.1274 20.6273 15.4194C25.4873 13.398 26.4971 13.0469 27.1553 13.0353C27.3001 13.0327 27.6238 13.0686 27.8335 13.2387C28.0105 13.3824 28.0592 13.5765 28.0825 13.7127C28.1058 13.8489 28.1349 14.1591 28.1118 14.4016C27.8484 17.1687 26.7089 23.8839 26.1291 26.9832C25.8838 28.2946 25.4008 28.7343 24.9332 28.7774C23.9169 28.8709 23.1452 28.1057 22.1609 27.4605C20.6207 26.4509 19.7505 25.8224 18.2555 24.8372C16.5277 23.6986 17.6477 23.0728 18.6324 22.0501C18.8901 21.7824 23.3678 17.7096 23.4544 17.3402C23.4653 17.294 23.4753 17.1217 23.373 17.0308C23.2707 16.9398 23.1197 16.9709 23.0107 16.9957C22.8562 17.0307 20.3957 18.657 15.6291 21.8746C14.9307 22.3542 14.2981 22.5879 13.7313 22.5756C13.1064 22.5621 11.9045 22.2223 11.011 21.9319C9.91502 21.5756 9.04399 21.3873 9.11984 20.7823C9.15934 20.4671 9.59331 20.1449 10.4217 19.8154Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_19993_139543"
        x1="20"
        y1="2.5"
        x2="20"
        y2="37.2404"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AABEE" />
        <stop offset="1" stopColor="#229ED9" />
      </linearGradient>
      <clipPath id="clip0_19993_139543">
        <rect width="35" height="35" fill="white" transform="translate(2.5 2.5)" />
      </clipPath>
    </defs>
  </svg>
);
